window.Plus = window.Plus || {};

Plus.SecondaryAddToCart = {
  init: init,
  makeSticky: makeSticky
};

document.addEventListener('DOMContentLoaded', function() {
  Plus.SecondaryAddToCart.init();
  Plus.SecondaryAddToCart.makeSticky();
});

if (window.Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', function() {
    Plus.SecondaryAddToCart.init();
    Plus.SecondaryAddToCart.makeSticky();
  });
}

/**
 * Secondary Add to Cart
 * ---------------------
 * Beardbrand no longer uses PDP quantity selectors.
 *
 * The secondary ATC proxies a click to the REAL primary PDP ATC.
 * This intentionally preserves the existing Recharge/cart behavior
 * instead of directly submitting Shopify's product form.
 *
 * - Jenny 9/2/26
 */
function init() {
  const secondaryAtcButton = document.querySelector('.secondary-atc-button');

  const primaryAtcButton = document.querySelector(
    'product-page product-form.product--add-to-cart-form button[name="add"].product__add-to-cart'
  );

  if (!secondaryAtcButton || !primaryAtcButton) {
    return;
  }

  // Prevent duplicate listeners if Shopify reloads the section
  if (secondaryAtcButton.dataset.plusSecondaryAtcBound === 'true') {
    return;
  }

  secondaryAtcButton.addEventListener('click', function(event) {
    event.preventDefault();

    // Prevent repeated clicks while the cart action is processing
    if (secondaryAtcButton.classList.contains('working')) {
      return;
    }

    // Do nothing if the currently selected variant is unavailable
    if (
      primaryAtcButton.classList.contains('disabled') ||
      primaryAtcButton.disabled ||
      primaryAtcButton.getAttribute('aria-disabled') === 'true'
    ) {
      return;
    }

    secondaryAtcButton.classList.add('working');

    /*
     * Trigger the real Beardbrand PDP button.
     *
     * Recharge's ATC harmonizer intentionally converts this button
     * from type="submit" to type="button" and manages its cart action.
     * Calling the actual button therefore preserves the same behavior
     * as a customer clicking the primary ATC.
     */
    primaryAtcButton.click();

    // Visual working-state fallback
    setTimeout(function() {
      secondaryAtcButton.classList.remove('working');
    }, 1500);
  });

  secondaryAtcButton.dataset.plusSecondaryAtcBound = 'true';
}


/**
 * Sticky Secondary ATC
 */
function makeSticky() {
  const secondaryAtcContainer = document.querySelector('.secondary-atc');
  const secondaryAtcInner = document.querySelector('.secondary-atc-section');

  const primaryAtcButton = document.querySelector(
    'product-page product-form.product--add-to-cart-form button[name="add"].product__add-to-cart'
  );

  if (
    !secondaryAtcContainer ||
    !secondaryAtcInner ||
    !primaryAtcButton
  ) {
    return;
  }

  if (
    secondaryAtcInner.classList.contains(
      'secondary-atc-section-position--static'
    )
  ) {
    return;
  }

  secondaryAtcContainer.classList.add('fixed');

  // Prevent duplicate scroll listeners in Shopify Theme Editor
  if (secondaryAtcContainer.dataset.plusStickyBound === 'true') {
    return;
  }

  function updateSecondaryAtcPosition() {
    const referencePosition =
      primaryAtcButton.getBoundingClientRect().bottom;

    if (referencePosition < 0) {
      secondaryAtcContainer.classList.remove('fixed--is-closed');
      secondaryAtcContainer.classList.add('fixed--is-open');
    } else {
      secondaryAtcContainer.classList.remove('fixed--is-open');
      secondaryAtcContainer.classList.add('fixed--is-closed');
    }
  }

  window.addEventListener(
    'scroll',
    updateSecondaryAtcPosition,
    { passive: true }
  );

  secondaryAtcContainer.dataset.plusStickyBound = 'true';

  updateSecondaryAtcPosition();
}